import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/bofang_icon.png'
import _imports_1 from '@/assets/images/roomHeat.png'
import _imports_2 from '@/assets/images/nofriendbg.png'


const _withScopeId = n => (_pushScopeId("data-v-7fc96d0d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "list"
}
const _hoisted_2 = { class: "itembox" }
const _hoisted_3 = { class: "userbox" }
const _hoisted_4 = { class: "userLeft" }
const _hoisted_5 = { class: "avatar" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "userinfo" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "nickname" }
const _hoisted_10 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_11 = {
  key: 1,
  class: "text"
}
const _hoisted_12 = {
  key: 0,
  class: "title van-ellipsis"
}
const _hoisted_13 = {
  key: 1,
  class: "title van-ellipsis"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "anchor-centen-box" }
const _hoisted_17 = { class: "anchor-centen-box-top" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "anchor-centen-box-bottom" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_22 = { class: "anchor-centen-bottem" }
const _hoisted_23 = { class: "ovehide" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 1,
  class: "noFriendBox"
}
const _hoisted_26 = { class: "defut" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_28 = { class: "title" }
const _hoisted_29 = { class: "tuijian" }
const _hoisted_30 = { class: "title" }
const _hoisted_31 = { class: "userinfo" }
const _hoisted_32 = { class: "info" }
const _hoisted_33 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_nav_bar, {
      title: $setup.t('me.zbxg'),
      "left-arrow": "",
      fixed: "",
      "z-index": "99",
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.ToBack($setup.router)))
    }, null, 8 /* PROPS */, ["title"]),
    ($setup.hotzb.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data, (item) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_van_image, {
                      width: "47",
                      height: "47",
                      round: "",
                      src: item.portrait
                    }, null, 8 /* PROPS */, ["src"]),
                    _createElementVNode("img", {
                      src: $setup.zbtype,
                      alt: ""
                    }, null, 8 /* PROPS */, _hoisted_6)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(item.nickName), 1 /* TEXT */),
                      (item.push_status == 1)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                        : _createCommentVNode("v-if", true),
                      (item.push_status == 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('match.onlive')), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]),
                    (item.push_status == 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(item.room_title), 1 /* TEXT */))
                      : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('match.noLiveMatch')), 1 /* TEXT */))
                  ])
                ]),
                _createElementVNode("div", {
                  class: "userRight",
                  onClick: ($event: any) => ($setup.enStart(item.user_id))
                }, _toDisplayString(_ctx.$t('me.qxgz')), 9 /* TEXT, PROPS */, _hoisted_14)
              ]),
              (item.push_status == 1)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "anchor-centen",
                    onClick: ($event: any) => ($setup.toLiveRoom(item))
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createCommentVNode(" <van-image fit=\"cover\" lazy-load v-if=\"item.screen_shots && item.screen_shots.length > 0\"\r\n              :src=\"item.screen_shots\" alt=\"\" /> "),
                      _createVNode(_component_van_image, {
                        fit: "cover",
                        "lazy-load": "",
                        src: item.room_cover,
                        alt: ""
                      }, null, 8 /* PROPS */, ["src"]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("img", {
                          class: "gif",
                          src: $setup.livezb,
                          alt: ""
                        }, null, 8 /* PROPS */, _hoisted_18),
                        _createCommentVNode(" <img v-if=\"item.room_id\" class=\"png\" :src=\"livetj\" alt=\"\"> ")
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _createElementVNode("div", null, [
                          _hoisted_21,
                          _createElementVNode("span", null, _toDisplayString(item.heat), 1 /* TEXT */)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("p", _hoisted_23, _toDisplayString(item.room_title), 1 /* TEXT */),
                      (item.nickName && item.nickName !== '')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(item.nickName), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ], 8 /* PROPS */, _hoisted_15))
                : _createCommentVNode("v-if", true)
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('noData.nozb')), 1 /* TEXT */),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('noData.noqgg')), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('im.wntuij')), 1 /* TEXT */),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.hotzb, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "zbbox"
              }, [
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_van_image, {
                    src: item.portrait,
                    width: "47",
                    height: "47",
                    round: "",
                    fit: "cover"
                  }, null, 8 /* PROPS */, ["src"]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("span", null, _toDisplayString(item.nickname), 1 /* TEXT */)
                  ])
                ]),
                _createElementVNode("div", {
                  class: "btn",
                  onClick: ($event: any) => ($setup.toStar(item.id))
                }, _toDisplayString(_ctx.$t('home.onFocus')), 9 /* TEXT, PROPS */, _hoisted_33)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
  ]))
}